export const checkIfRequestStorageAccessEnabled = () =>
  typeof document.requestStorageAccess === 'function';
